import logo from "assets/images/logoWhite.svg";
import ".././sidebar.css";
import { TalentSidebar } from "./TalentSidebar";
import { RecruiterSidebar } from "./RecruiterSidebar";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { CorporateRecruiter } from "./CorporateRecruiter";


interface SidebarProps {
  startTour: () => void;
}
export const SideBar = ({ startTour }: SidebarProps) => {
  const { userInfo } = useGetUserInfo();
  return (
    <div className="bg-primary h-screen w-full">
      <div>
        <div className="py-4 px-6">
          <a
            href="https://www.arnopro.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo} alt="logo" />
          </a>
        </div>
        {userInfo?.recruiter?.is_corporate === 0 && (
          <RecruiterSidebar startTour={startTour} />
        )}
        {userInfo?.type === "talent" && <TalentSidebar startTour={startTour} />}
        {userInfo?.recruiter?.is_corporate === 1 && <CorporateRecruiter />}
      </div>
    </div>
  );
};
